const medium = '800x800';
const small = '200x200';

export { medium, small };
